import * as React from 'react';
import { clsx as cx } from 'clsx';

import { ILinkProps } from './types';

import * as styles from './Link.css';

export const Link = ({ children, theme, underlined, testId, ref, ...rest }: ILinkProps) => {
  return (
    <a
      ref={ref}
      data-testid={testId || 'link'}
      className={cx(
        styles['link'],
        theme === 'primary' && styles['primary'],
        theme === 'accent' && styles['accent'],
        theme === 'light' && styles['light'],
        underlined && styles['underlined'],
      )}
      {...rest}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};
